<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="800px"
      scrollable
      @keydown="executeCloseModalCreateOrUpdate"
      @click:outside="executeCloseModalCreateOrUpdate"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>
            {{ currentWebhook ? "Actualizar" : "Crear" }} Webhook
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="">
            <v-form @submit.prevent="sendUpdateOrCreateWebhook">
              <v-row align-content="center" class="mt-2">
                <v-col cols="12" md="12" sm="12" class="pt-0">
                  <label for="name">
                    <b> Nombre del Webhook * </b>
                  </label>
                  <v-text-field
                    :placeholder="`Ingresa el Nombre del Webhook`"
                    v-model="$v.form.name.$model"
                    :error="$v.form.name.$invalid && submitUpload"
                    :error-messages="
                      $v.form.name.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" sm="12" class="pt-0">
                  <label for="url">
                    <b> URL del Webhook * </b>
                  </label>
                  <v-text-field
                    :placeholder="`Ingresa la URL del Webhook`"
                    v-model="$v.form.url.$model"
                    :error="$v.form.url.$invalid && submitUpload"
                    :error-messages="
                      $v.form.url.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" sm="12" class="pt-0">
                  <label for="secret">
                    <b> Secret del Webhook * </b>
                  </label>
                  <v-text-field
                    :placeholder="`Ingresa el Secret del Webhook`"
                    v-model="$v.form.secret.$model"
                    :error="$v.form.secret.$invalid && submitUpload"
                    :error-messages="
                      $v.form.secret.$invalid && submitUpload
                        ? 'Este campo es requerido'
                        : null
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" sm="12" class="pt-0">
                    <label for="event">
                      <b> Evento del Webhook * </b>
                    </label>
                    <v-autocomplete
                      :placeholder="`Ingresa el Evento del Webhook`"
                      :items="listEventOptions"
                      v-model="$v.form.event.$model"
                      :error="$v.form.event.$invalid && submitUpload"
                      :error-messages="
                         $v.form.event.$invalid && submitUpload
                            ? 'Este campo es requerido'
                            : null
                      "
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" sm="12" class="pt-0">
                  <label>
                    <b> Headers del Webhook </b>
                  </label>
                  <br>
                  <small class="text-primary mt-3">
                      <v-icon color="primary" class="mr-1">
                       mdi-information-outline
                      </v-icon> 
                      <span>Puedes editar los headers haciendo click en la celda de la tabla</span>
                  </small>
                  <v-row class="mt-2" align="center">
                    <v-col cols="5">
                      <v-text-field
                        v-model="newHeader.key"
                        placeholder="Clave"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        v-model="newHeader.value"
                        placeholder="Valor"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                        icon
                        color="primary"
                        :disabled="!newHeader.key || !newHeader.value"
                        @click="addHeader"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-simple-table v-if="localHeaders.length > 0" class="mt-3">
                    <thead>
                      <tr>
                        <th class="text-center">Clave</th>
                        <th class="text-center">Valor</th>
                        <th class="text-center">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(header, index) in localHeaders" :key="index">
                        <td>
                          <v-edit-dialog
                            @save="updateHeaderKey(index)"
                            @cancel="cancelEdit"
                          >
                            {{ header.key }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="header.key"
                                label="Editar clave"
                                single-line
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td>
                          <v-edit-dialog
                            @save="updateHeaderValue(index)"
                            @cancel="cancelEdit"
                          >
                            {{ header.value }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="header.value"
                                label="Editar valor"
                                single-line
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td class>
                          <section class="mx-auto text-center">
                            <v-btn
                              icon
                              
                              color="red"
                              @click="removeHeader(index)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </section>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <small v-else class="grey--text mt-2">
                    No hay headers agregados
                  </small>
                </v-col>
                 <v-col
                  cols="12"
                  md="12"
                  sm="12"
                  class="pb-0"
                >
                  <v-row align-content="center" class="mt-2">
                    <v-col cols="12" md="6" sm="12" class="pt-0">
                      <label class="mt-1 mb-2">
                        <b> Activo</b>
                      </label>
                      <v-checkbox
                        hide-details
                        class="mt-0 mb-2"
                        v-model="form.active"
                        :true-value="true"
                        :false-value="false"
                      >
                      </v-checkbox>
                       <small class="text-primary mt-2">
                        Determina si el webhook se encuentra activo o inactivo
                      </small>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalCreateOrUpdate"
          >
            <small> Cancelar </small>
          </v-btn>
          <v-btn
            @click="sendUpdateOrCreateWebhook"
            :color="`${currentWebhook ? 'warning' : 'primary'} text-white`"
            small
            class="float-right"
          >
            {{ currentWebhook ? "Actualizar" : "Crear" }} Webhook
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required } from "vuelidate/lib/validators";
import { LIST_EVENTS_OPTIONS } from "@/constants/settings";
import swal2 from "sweetalert2";

export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalCreateOrUpdateWebhook: {
      type: Function,
      default: () => {},
    },
    currentWebhook: {
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        name: null,
        url: null,
        secret: null,
        event: null,
        headers: {},
        active: true,
      },
      listEventOptions: LIST_EVENTS_OPTIONS,
      newHeader: { key: "", value: "" },
      localHeaders: [],
      submitUpload: false,
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        url: { required },
        secret: { required },
        event: { required },
        headers: {},
        active: {},
      },
    };
  },
  methods: {
    ...mapActions({
      updateWebhook: "settings/updateWebhook",
      createWebhook: "settings/createWebhook",
    }),
    addHeader() {
      if (this.newHeader.key && this.newHeader.value) {
        this.localHeaders.push({ ...this.newHeader });
        this.newHeader = { key: "", value: "" };
        this.syncHeadersToForm();
      }
    },
    updateHeaderKey(index) {
      this.syncHeadersToForm();
    },
    updateHeaderValue(index) {
      this.syncHeadersToForm();
    },
    cancelEdit() {},
    removeHeader(index) {
      this.localHeaders.splice(index, 1);
      this.syncHeadersToForm();
    },
    syncHeadersToForm() {
      const headers = {};
      this.localHeaders.forEach((h) => {
        headers[h.key] = h.value;
      });
      this.form.headers = headers;
    },
    convertHeadersToLocal(headers) {
      if (headers && typeof headers === "object") {
        this.localHeaders = Object.entries(headers).map(([key, value]) => ({
          key,
          value,
        }));
      } else {
        this.localHeaders = [];
      }
    },
    async sendUpdateOrCreateWebhook() {
      let self = this;
      self.submitUpload = true;
      if (!self.$v.form.$invalid) {
        self.loading = true;
        let resp = null;
        if(self.currentWebhook) {
          resp = await self.updateWebhook({
            id: self.currentWebhook.id,
            ...self.form,
          });
        } else {
          resp = await self.createWebhook({
            ...self.form,
          });
        }
        if (resp?.status == 200 || resp?.status == 201) {
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: self.currentWebhook
              ? `Webhook actualizada correctamente`
              : `Webhook creada correctamente`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("webhookUpdatedOrCreated");
          this.closeModalCreateOrUpdateWebhook(true);
          this.resetForm();
        }
        if (!resp.status || resp.status === 400 || resp.status === 500) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp?.data?.detail || "Ha ocurrido un error en el servidor, intenta nuevamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    executeCloseModalCreateOrUpdate($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalCreateOrUpdateWebhook($event);
      }
    },
    setWebhook(webhook) {
      this.form = {
        name: webhook.name,
        url: webhook.url,
        secret: webhook.secret,
        event: webhook.event,
        headers: webhook.headers,
        active: webhook.active,
      };
      this.convertHeadersToLocal(webhook.headers);
    },
    resetForm() {
      this.form = {
        name: null,
        url: null,
        secret: null,
        event: null,
        headers: {},
        active: true,
      };
      this.localHeaders = [];
      this.newHeader = { key: "", value: "" };
      this.submitUpload = false;
    },
  },
  computed: {
    ...authUsuarioComputed,
  },
  watch: {
    currentWebhook(newForm) {
      if (newForm) {
        this.setWebhook(newForm);
      } else {
        this.resetForm();
      }
    },
  },
};
</script>

<style></style>
